/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_scoring_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our scoring engine replicates the official F1 Fantasy point system, including:`)
};

const es_about_scoring_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuestro motor de puntuación replica el sistema oficial de puntos F1 Fantasy, incluyendo:`)
};

const de_about_scoring_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsere Bewertungs-Engine repliziert das offizielle F1 Fantasy Punktesystem, einschließlich:`)
};

const nl_about_scoring_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onze scoring-engine repliceert het officiële F1 Fantasy-puntensysteem, inclusief:`)
};

const fr_about_scoring_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notre moteur de notation reproduit le système officiel de points F1 Fantasy, incluant :`)
};

const it_about_scoring_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il nostro motore di punteggio replica il sistema ufficiale di punti F1 Fantasy, inclusi:`)
};

const pt_br2_about_scoring_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nosso motor de pontuação replica o sistema oficial de pontos do F1 Fantasy, incluindo:`)
};

const pt_about_scoring_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O nosso motor de pontuação replica o sistema oficial de pontos do F1 Fantasy, incluindo:`)
};

const ja_about_scoring_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当スコアリングエンジンは公式F1ファンタジーポイントシステムを再現しています:`)
};

const zh_about_scoring_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们的评分引擎复制了官方F1 Fantasy积分系统，包括：`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_scoring_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_scoring_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_scoring_intro", locale)
	if (locale === "en") return en_about_scoring_intro(inputs)
	if (locale === "es") return es_about_scoring_intro(inputs)
	if (locale === "de") return de_about_scoring_intro(inputs)
	if (locale === "nl") return nl_about_scoring_intro(inputs)
	if (locale === "fr") return fr_about_scoring_intro(inputs)
	if (locale === "it") return it_about_scoring_intro(inputs)
	if (locale === "pt-BR") return pt_br2_about_scoring_intro(inputs)
	if (locale === "pt") return pt_about_scoring_intro(inputs)
	if (locale === "ja") return ja_about_scoring_intro(inputs)
	return zh_about_scoring_intro(inputs)
};